/**
 * Field configurations for Schedule API endpoints
 * These define which fields to request from the API
 */

const SCHEDULE_FIELDS_MINIMAL = {
  id: true,
  name: true,
} as const;

const SCHEDULE_FIELDS_DEFAULT = {
  id: true,
  name: true,
  description: true,
  isWeeklyGrid: true,
  weekStartDate: true,
  knockoutStartDate: true,
  knockoutStartTime: true,
  club: {
    id: true,
    name: true,
    status: true,
    address: {
      id: true,
      street: true,
      city: true,
      state: true,
      zipCode: true,
      latitude: true,
      longitude: true,
      timezone: true,
    },
    courts: {
      id: true,
      name: true,
      surface: true,
      wallType: true,
    },
  },
  schedule: {
    date: true,
    dayOfWeek: true,
    timeRange: {
      qty: true,
      courtsQuantity: true,
      startTime: true,
      endTime: true,
    },
  },
} as const;

/**
 * DEFAULT plus the tournaments already using each schedule. Needed to decide
 * whether a block can be shared with the tournament being created or edited.
 */
const SCHEDULE_FIELDS_WITH_TOURNAMENTS = {
  ...SCHEDULE_FIELDS_DEFAULT,
  tournaments: {
    id: true,
    name: true,
    status: true,
    format: true,
    sport: {
      uid: true,
    },
  },
} as const;

export const SCHEDULE_FIELDS = {
  MINIMAL: SCHEDULE_FIELDS_MINIMAL,
  DEFAULT: SCHEDULE_FIELDS_DEFAULT,
  WITH_TOURNAMENTS: SCHEDULE_FIELDS_WITH_TOURNAMENTS,
} as const;
